import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@repo/share-log-web-utils";

const badgeVariants = cva(
  "inline-flex items-center px-2 py-0.5 text-xs font-medium rounded",
  {
    variants: {
      variant: {
        default: "bg-primary/10 text-primary",
        expense: "bg-expense-muted text-expense-foreground",
        income: "bg-income-muted text-income-foreground",
        success: "bg-success-muted text-success-foreground",
        warning: "bg-warning-muted text-warning-foreground",
        info: "bg-info-muted text-info-foreground",
        muted: "bg-muted text-muted-foreground",
      },
      shape: {
        default: "rounded",
        pill: "rounded-full",
      },
    },
    defaultVariants: {
      variant: "default",
      shape: "default",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, shape, ...props }: BadgeProps) {
  return (
    <span
      className={cn(badgeVariants({ variant, shape }), className)}
      {...props}
    />
  );
}
